interface EditorPanelNodeSelectorOptions {
	paramId: CoreGraphNodeId;
}
import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {ref, Ref} from '@vue/composition-api';
export class EditorPanelNodeSelectorStoreControllerClass {
	private static _instance: EditorPanelNodeSelectorStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorPanelNodeSelectorStoreControllerClass());
	}

	private constructor() {}

	private _paramId!: Ref<CoreGraphNodeId | null>;
	init() {
		this._paramId = ref(null);
	}

	// getters
	paramId(): CoreGraphNodeId | null {
		return this._paramId.value;
	}

	// mutations
	open(options: EditorPanelNodeSelectorOptions): void {
		this._paramId.value = options.paramId;
	}
	close() {
		this._paramId.value = null;
	}
}

export const EditorPanelNodeSelectorStoreController = EditorPanelNodeSelectorStoreControllerClass.instance();
